import { render, staticRenderFns } from "./StoreSearch.vue?vue&type=template&id=4f70fa1f&scoped=true"
import script from "./StoreSearch.vue?vue&type=script&lang=js"
export * from "./StoreSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f70fa1f",
  null
  
)

export default component.exports